import { h } from 'preact';
import clsx from 'clsx';

const Title = ({ settings }) => {
  const {
    block_id: blockId,
    background,
    image,
    video,
    text,
    cta_text: ctaText,
    cta_link: ctaLink,
    desktop_layout: desktopLayout,
    text_color: textColor
  } = settings;
  return (
    <div
      id={blockId}
      style={{
        backgroundColor: background,
        backgroundImage: image ? `url(${image})` : background,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: textColor
      }}
      className={clsx(
        'flex items-center scroll-mt-20 relative px-5 justify-center text-center flex-col aspect-[2] col-span-2',
        desktopLayout,
      )}
    >
      {video && (
        <div className="absolute inset-0 w-full h-full">
          <video
            loop
            muted
            autoPlay
            playsInline
            className="w-full h-full object-cover"
          >
            {video.sources.map((source, index) => (
              <source
                key={index}
                src={source.url}
                type={source.mime_type}
              ></source>
            ))}
          </video>
        </div>
      )}
      <div
        className="relative heading rte"
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
      {ctaText && ctaLink && (
        <a
          href={ctaLink}
          className="tracking-[0.02em] cta-small mt-5 underline relative"
        >
          {ctaText}
        </a>
      )}
    </div>
  );
};

export default Title;
